import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context, Entity, Metadata } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import { MetaDataHelper } from "../core/util/metaDataHelper.js";
import { Commands } from "../core/util/commandManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Config } from "../core/config/config.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { General } from "../../siteManagement/general.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { CreateAssignment, CreateAssignmentAppProps } from "../ticket/createAssignment.js";
import { Sheet, SheetEventType } from "../../siteManagement/sheet.js";
import { EventType } from "../../siteManagement/eventManager.js";
import { PageTitleProps } from "../core/components/pageTitle.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import Skills from "../core/components/skills.js";
import React from "react";
import ProjectResourceGrid from "./projectResourceGrid.js";

export class ProjectApp extends React.Component<ProjectAppProps, ProjectAppState> {
    private firstProjNr = true;
    private lockId: number;
    common = new AppHelper();
    currentUrl: string = null;
    translations: {};
    deleteEnabled = false;
    isDeleted = false; //!!!!!!!!
    articleGridOptions: {};
    machinesGridOptions: {};
    projectContactsGridOptions: {};
    addressContactsGridOptions: {};
    projectResourceGridOptions: {};
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    canAddAssignment = false;
    maschNr = null;
    private _metaDataCopy: Metadata;
    private sheet: Sheet;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.state = {
            assignmentAddressChanged: false
        }
        this._initApp();
    }


    private updateCurrentUrl() {
        if (this.props.entity.IsNew) {
            this.currentUrl = Config.baseUrl + "Project/New";
        } else {
            this.currentUrl = Config.baseUrl + "Project/Edit/" + this.props.entity.Projnr;
        }
    }

    private reloadContactPerson(adrNr: string) {
        HTTPService.get('ProjectLookup/GetAnsprechpartner?adrNr=' + encodeURIComponent(adrNr))
            .then(result => {
                this.props.dataSources["ansprechpartnerDataSource"].length = 0;
                for (let i = 0; i < result.length; i++) {
                    this.props.dataSources["ansprechpartnerDataSource"].push(result[i]);
                }
                this.common.commandManager.runCommand("entity.Bearbeiter2", Commands.RELOADDATASOURCE);
            });
    }

    private getPreisliste(liste: string) {
        HTTPService.get('InvoiceLookup/GetPlistensWithTab/?liste=' + encodeURIComponent(liste))
            .then(result => {
                this.props.dataSources["preislisteDataSource"].length = 0;
                for (let i = 0; i < result.length; i++) {
                    this.props.dataSources["preislisteDataSource"].push(result[i]);
                }
                this.common.commandManager.runCommand("entity.Preisliste", Commands.RELOADDATASOURCE);
            });
    }

    private doOnVskChanged(value) {
        if (value === "2")
            this.getPreisliste("SPLISTE1");
        else
            this.getPreisliste("PLISTE");
    }

    private setAddressData(adrNr) {
        HTTPService.get<JsonResultClass>('Address/Get/?id=' + encodeURIComponent(this.props.entity.Adrnr))
            .then(result => {
                if (result.Code === 0) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Vsk", result.Data.Vsk);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Language", result.Data.Language);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Zb", result.Data.Zb);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Preisliste", result.Data.Preisliste);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Verrechnung", result.Data.Verrechnung);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Currency", result.Data.Currency);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Papiere", result.Data.Papiere);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Rechnungen", result.Data.Rechnungen);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Lieferscheine", result.Data.Lieferscheine);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Zalohnsatz", result.Data.Zalohnsatz);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Zaspesensatz", result.Data.Zaspesensatz);
                    this.doOnVskChanged(result.Data.Vsk);
                    this.setState({});
                } else {
                    NotificationHelper.showErrorMessage(result.AdditionalData?.readPermissionDeniedReasons[0]?.Reason || result.Message);
                }
            });
    }

    private refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }

    private updateAddressTree = (model, value = null) => {
        HTTPService.get<JsonResultClass>("Address/GetShortTree?id=" + encodeURIComponent(Helper.getValueOrDefault(value, this.props.entity.Adrnr)))
            .then(result => {
                if (result.Code === 0) {
                    const adrnr = Helper.hasValue(result.Data["0"]) ? result.Data["0"] : this.props.entity.Adrnr;
                    const refLevel1 = Helper.hasValue(result.Data["1"]) ? result.Data["1"] : adrnr;
                    const refLevel2 = Helper.hasValue(result.Data["2"]) ? result.Data["2"] : refLevel1;

                    if (model === "entity.Adrnr") {
                        if (!Helper.hasValue(this.props.entity.Adrnr2) || this.props.entity.Adrnr2.trim() === "") {
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.Adrnr2", refLevel1);
                        }
                        this.checkAndSetDebtor(refLevel2);
                        let adrnr = Helper.hasValue(value) ? value : this.props.entity.Adrnr;
                        this.setAddressData(adrnr);

                    } else if (model === "entity.Adrnr2") {
                        this.checkAndSetDebtor(refLevel1);
                    }

                    this.setState({});
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private checkAndSetDebtor = (value) => {
        if ((!Helper.hasValue(this.props.entity.Adrnr3) || this.props.entity.Adrnr3.trim() === "") && Helper.hasValue(value)) {
            HTTPService.get<JsonResultClass>("Address/IsDisabled?id=" + encodeURIComponent(value))
                .then(result => {
                    if (result.Code === 0) {
                        if (result.Data === true) {
                            NotificationHelper.showErrorMessage(this.translations["WebSMS.Project.UngültigeDebitoradresse"] + " " + result.Message);
                        } else {
                            MetaDataHelper.setFieldValue(this.props.entity, "entity.Adrnr3", value);
                            this.setState({});
                        }
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }

    private loadProjectStatus = (id: number) => {
        const oldStatus = this.props.entity.Status;
        const oldProjectStatus = this.props.entity.ProjectStatus;

        const update = (projectStatus) => {
            let newEntity = this.props.entity;
            newEntity.ProjectStatus = projectStatus;
            Helper.updateEntity(this.props.entity, newEntity);
            this.setState({}, this.updateGui);
        }

        const ask = async (projectStatus) => {
            const isOk = await DialogHelper.confirm(this.translations["WebSMS.GeneralSettings.Project.Status.Sure"]);
            if (isOk) {
                this.save(false);
                update(projectStatus);
            } else {
                //reset
                let newEntity = this.props.entity;
                newEntity.Status = oldStatus;
                newEntity.ProjectStatus = oldProjectStatus;
                Helper.updateEntity(this.props.entity, newEntity);
                this.setState({}, this.updateGui);
            }
        }

        let url = "ProjectLookup/GetProjectStatus?Id=" + id;
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    if (!result.Data.Editing && this.props.entity.ProjectStatus.Editing) {
                        ask(result.Data);
                    } else {
                        update(result.Data);
                    }
                    let sheet = General.Sheet.Manager.getTopMostSheet();
                    sheet.trigger(SheetEventType.Custom, { command: "reportAcquisitionChanged", value: result.Data.ReportAcquisition });
                }
            });
    }

    private updateGui = () => {
        const value = this.props.entity.ProjectStatus.Editing;
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.trigger(SheetEventType.Custom, { command: "projectStatusChanged", value: value });
        if (value) {
            this.reloadMetaData();
        } else {
            this.setReadOnly();
        }
    }

    private setReadOnly = () => {
        this._metaDataCopy = JSON.parse(JSON.stringify(this.props.metadata)); // Shame Shame Shame
        this.props.metadata.tabs.forEach((tab) => {
            if (Helper.hasValue(tab.regions)) {
                tab.regions.forEach((region) => {
                    region.fields.forEach((field) => {
                        field.readOnly = (field.model !== "entity.Status");
                    });
                });
            }
        });
        this.setState({});
    }

    private reloadMetaData = () => {
        const metadata: Metadata = this._metaDataCopy || this.props.metadata;
        metadata.tabs.forEach((tab, i) => {
            if (Helper.hasValue(tab.regions)) {
                tab.regions.forEach((region, j) => {
                    region.fields.forEach((field, k) => {
                        this.props.metadata.tabs[i].regions[j].fields[k].readOnly = field.readOnly;
                    });
                });
            }
        });
        this.setState({});
    }

    releaseLock = () => {
        if (this.lockId != undefined) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.IsId, "KUNDE");
            this.lockId = undefined;
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Projnr":
                //MetaDataHelper.setFieldValue(this.props.entity, field.model, value);
                break;
            case "entity.Startsoll":
                if (Helper.hasValue(value)) {
                    let startSoll = kendo.parseDate(value);
                    let endeSoll = kendo.parseDate(this.props.entity.Endesoll);
                    if (startSoll > endeSoll) {
                        startSoll.setHours(endeSoll.getHours());
                        startSoll.setMinutes(endeSoll.getMinutes());
                        startSoll.setSeconds(endeSoll.getSeconds())
                        MetaDataHelper.setFieldValue(this.props.entity, "entity.Endesoll", startSoll);
                    }
                }
                break;
            case "entity.Adrnr":
                if (Helper.hasValue(value)) {
                    this.updateAddressTree(field.model, value);
                }
                if (!this.props.entity.IsNew)
                    this.setState({ assignmentAddressChanged: true });
                break;
            case "entity.Adrnr2":
                if (Helper.hasValue(value)) {
                    this.updateAddressTree(field.model, value);
                }
                break;
            case "entity.Adrnr3":
                if (Helper.hasValue(value) && value !== "") {
                    this.checkAndSetDebtor(value);
                }
                break;
            case "entity.Vsk":
                this.doOnVskChanged(value);
                break;
            case "entity.Status":
                //this._checkIfCanAddAssignment();
                this.loadProjectStatus(value);
                break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    handleIsSearchFieldFullObjectModel = (field, dataItem) => {
        let changed = true;
        switch (field.model) {

            default:
                changed = false;
                break;
        }

        if (changed) {
            this.common.handleFieldChange({ model: "" }, null, null);
        }
    }

    handleDataLoaded = (field, data) => {
        //if (field.model === "entity.Ressnrbearbeiter" && this.props.entity.Bearbeiter1 !== data.Name) {
        //    this.handleFieldChange({ model: "entity.Bearbeiter1" }, data.Name);
        //}
        this.common.handleDataLoaded(field, data);
    }

    remove = () => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>('Project/Delete?id=' + this.props.entity.Projnr)
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                            if (this.common.isWindow) {
                                this.common.sheetWrapper.hide();
                            } else {
                                this.deleteEnabled = false;
                                this.isDeleted = true;
                                this.props.entity.RecordRight.CanWrite = false;
                                this.setState({});
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "DynamicSearch/Project";
                                }, 1000);
                            }
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    save = (closeAfterSave) => {
        for (const loadedModule of this.common.getLoadedModules()) {
            loadedModule.Save();
        }

        if (this.common.validate()) {
            const saveData: StringKeyDictionary<any> = {
                vm: this.props.entity
            };
            if (Helper.hasValue(this.props.context.initMachine)) {
                saveData["maschNr"] = this.props.context.initMachine;
                saveData["fullMaschTree"] = true;
            }
            if (!Helper.hasValue(saveData["maschNr"]) && Helper.hasValue(this.maschNr)) {
                saveData["maschNr"] = this.maschNr;
                saveData["fullMaschTree"] = false;
            }
            if (Helper.hasValue(this.props.context.initTicket)) {
                saveData["problemNr"] = this.props.context.initTicket;
            }

            HTTPService.post<JsonResultClass>("Project/Save", saveData)
                .then(result => {
                    if (result.Code === 0) {
                        if (this.props.entity.IsNew /*&& !this.common.isWindow*/) {
                            const data = this.common.sheetWrapper.getExternalData();
                            if (!data || data.preventUrlChangeOnNew !== true) {
                                General.Functions.HistoryState.replaceState("Project/Edit?id=" + encodeURIComponent(this.props.entity.Projnr));
                            }
                        }
                        if (Helper.hasValue(result.Data.IsId) && this.lockId == undefined) {
                            this.lockId = Helper.keepLockAlive("Lock.ashx", result.Data.IsId, "KUNDE", 10000);
                        }
                        let indivData = result.Data.IndividualFields
                        Helper.updateEntity(this.props.entity, result.Data);
                        for (var key in indivData) {
                            this.props.entity.IndividualFields[key] = indivData[key];
                        }
                        this.props.entity.IsNew = false;
                        this.refreshDeleteEnabled();
                        $(window).trigger("saveSkills", this.props.entity);
                        NotificationHelper.showSuccessMessage(result.Message);
                        if (this.state.assignmentAddressChanged)
                            this.requestUpdateAssignmentsAddress();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    let copiedEntity = JSON.parse(JSON.stringify(this.props.entity));
                    copiedEntity.IsSaved = true;
                    Helper.updateEntity(this.props.entity, copiedEntity);
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                });
        }
    }

    requestUpdateAssignmentsAddress = async () => {
        DialogHelper.choose(Helper.getTranslation("Einsatz.MsgChangeAssignmentAddress"), [
            { label: this.translations["Server.No"], value: 0, primary: false },
            { label: Helper.getTranslation("Einsatz.OnlyFuture"), value: 2, primary: false },
            { label: Helper.getTranslation("Einsatz.YesAll"), value: 1, primary: true }], false, 1000).then((state: number) => {
                if (Helper.hasValue(state) && state > 0) {
                    this.updateAssignmentsAddress(state == 1);
                }
            });
    }

    updateAssignmentsAddress = async (updateAll: boolean) => {
        let result = await HTTPService.post<JsonResultClass>("Project/UpdateAssignmentsAddress?projNr=" + encodeURIComponent(this.props.entity.Projnr) + "&allAssignments=" + encodeURIComponent(updateAll));
        if (result.Code == 0) {
            General.Events.trigger(EventType.Custom,
                { cmd: updateAll ? "changedAdrNr" : "changedAdrNrFuture", data: this.props.entity.Adrnr });
            NotificationHelper.showSuccessMessage(result.Message);
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        this.setState({ assignmentAddressChanged: false });
    }

    openCreateMultipleAssignments = () => {
        if (Config.user.canCreateAssignment !== true)
            return;

        General.Sheet.Manager.createSheetWithUrl(`${Config.baseUrl}CreateMultipleAssignments/Index?projNr=${this.props.entity.Projnr}`);
    }

    projectIndividualDataProps = () => {
        return { readonly: !this.props.entity.ProjectStatus.Editing }
    }

    openCreateAssignment = () => {
        if (Config.user.canCreateAssignment !== true)
            return;

        const getHourAndMinute = (timeString) => {
            let h = null, m = null;
            if (timeString.length === 5) {
                h = parseInt(timeString.substr(0, 2), 10);
                m = parseInt(timeString.substr(3, 2), 10);
            }
            return { h: h, m: m };
        }

        const updateTime = (date, timeString) => {
            const time = getHourAndMinute(timeString);
            date.setHours(time.h);
            date.setMinutes(time.m);
        }

        if (this.props.entity.ProjectStatus.AssignmentGeneration) {
            HTTPService.chainBatch
                .add<JsonResultClass>("Procedure/AssignmentInit")
                .add<Metadata>(Helper.getMetaData("createAssignment"))
                .add("Procedure/AssignmentSettings")
                .add<JsonResultClass>("ResourcePlanning/DefaultResourceForProject?projNr=" + encodeURI(this.props.entity.Projnr))
                .promise()
                .then(results => {
                    const entity = results[0].Data;
                    const metaData = results[1];
                    if (metaData && metaData.rightDrawerContainer) {
                        let comp = metaData.rightDrawerContainer.multipleComponents.find(comp => comp.iskey === "RIGHTDRAWER_COMPONENT_IFRAME");
                        if (comp) {
                            comp.props.url = "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/e973c00a-83ce-45a6-851f-043a079b9242.html";
                        }
                    }
                    const settings = results[2];
                    const res = results[3];

                    //set default data
                    entity.Ticket = null;
                    entity.Project = this.props.entity.Projnr;
                    entity.ProjectCode = "0_";
                    entity.Resource = res.Data;
                    entity.ResourceAssignment = true;
                    entity.Address = this.props.entity.Adrnr;

                    entity.StartDate = Helper.dates.toDate(this.props.entity.Startsoll);
                    entity.EndDate = Helper.dates.toDate(this.props.entity.Endesoll);
                    updateTime(entity.StartDate, settings.WorkStartTime);
                    updateTime(entity.EndDate, settings.WorkEndTime);

                    const sheet = General.Sheet.Manager.createSheet();
                    sheet.setTitle(this.translations["WebSMS.Ticket.Assignment.NewAssignment"]);
                    sheet.show(() => {
                        const props: CreateAssignmentAppProps = {
                            entity: entity,
                            context: { key1: "", key2: "", keyVal1: null, contextType: "assignmentFromTicket" },
                            metadata: metaData,
                            dataSources: {
                                assignmentTypesDS: null
                            },
                            isWindow: true,
                            settings: settings,
                            defaultDeadline: Helper.dates.toString(this.props.entity.Endesoll, true),
                            handleMenuSelect: null,
                            enableMenuItem: null,
                            handleCreateValidator: null,
                            handleFieldChange: null,
                            handleDataLoaded: null,
                            onChange: null,
                            fromProject: true
                        };

                        sheet.mountContent(CreateAssignment, props);
                    });
                    sheet.bind(SheetEventType.Close, () => {
                        this.sheet.trigger(SheetEventType.Custom, { cmd: "updateAssignments" })
                    })
                });
        }
    }

    projectMachinesSearch = () => {
        const url = "DynamicSearch/Window/Machine/?multi=false&displayPattern=[[maschnr]] [[maschbezeichnung]]&status=0";
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.setTitle(this.translations["Maschine.Maschinensuche"]);
        sheet.bind(SheetEventType.RowClicked, (data) => {
            if (data.length > 0) {
                HTTPService.chainBatch
                    .add<{ AdrNr: string }>("MachineLookup/MachineHeader?id=" + encodeURIComponent(data))
                    .add<JsonResultClass<boolean>>(url)
                    .promise()
                    .then(result => {
                        this.handleFieldChange({ model: "entity.Adrnr" }, result[0].AdrNr, true);
                        this.maschNr = data;
                    });
            }
        });
    }

    createSkills = () => {
        let entity: any = this.props.entity;
        return <Skills entity={entity} runningContext="project" onTreeDataChanged={() => { this.common.setEntityDirtyState(true); }}
            title={Helper.getTranslation["WebSMS.Skills.Skills"]} useSkillProfile={false} editable={this.props.entity.RecordRight.CanWrite} />;
    }

    renderProjectResourceGrid = () => {
        return <ProjectResourceGrid
            entity={this.props.entity}
            gridOptions={this.projectResourceGridOptions}
        />
    }

    private _initApp = () => {
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.updateCurrentUrl();
        if (Helper.hasValue(this.props.entity.Adrnr3)) {
            this.reloadContactPerson(this.props.entity.Adrnr3);
        }

        this.refreshDeleteEnabled();

        this.props.dataSources["ansprechpartnerDataSource"] = [];
        this.props.dataSources["preislisteDataSource"] = [];

        if (Helper.hasValue(this.props.context.initAddress)) {
            this.handleFieldChange({ model: "entity.Adrnr" }, this.props.context.initAddress, true);
        }
        if (Helper.hasValue(this.props.context.initMainGroup)) {
            this.handleFieldChange({ model: "entity.Ogrnr" }, this.props.context.initMainGroup, true);
        }

        this.handleFieldChange({ model: "entity.Vsk" }, this.props.entity.Vsk, null, true);

        this.props.context.materialGrid = this.articleGridOptions;
        this.props.context.machinesGrid = this.machinesGridOptions;
        this.props.context.projectContactsGrid = this.projectContactsGridOptions;
        this.props.context.addressContactsGrid = this.addressContactsGridOptions;

        if (this.props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(() => {
                this.releaseLock();
            });
        }
        this.canAddAssignment = !this.props.entity.IsNew && this.props.canAddAssignment;
    }

    componentDidMount() {
        if (this.props.entity.RecordRight.CanWrite && Helper.hasValue(this.props.entity.IsId) && !this.props.entity.IsNew) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.IsId, "KUNDE", 10000);
        }
        this.updateGui();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel, handleDataLoaded: this.handleDataLoaded });

        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.Projnr,
            locked: Helper.hasValue(this.props.entity.LockMessage) && this.props.entity.LockMessage.trim() !== "",
            lockInfo: this.props.entity.LockMessage
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
};

interface ProjectAppState {
    assignmentAddressChanged: boolean;
}

export interface ProjectAppProps extends AppBaseProps {
    entity: EntityProject;
    context: ProjectAppPropsContext;
    canAddAssignment: boolean;
}

interface ProjectAppPropsContext extends Context {
    initAddress: string;
    initMachine: string;
    initTicket?: number;
    initMainGroup?: number;
    machinesGrid?: {};
    materialGrid?: {};
    projectContactsGrid?: {};
    addressContactsGrid?: {};
}

export interface EntityProject extends Entity {
    Projnr: string;
    Adrnr: string;
    Adrnr2: string;
    Adrnr3: string;
    Bearbeiter1: string;
    IsId?: number;
    LockMessage?: string;
    Startsoll?: Date;
    Endesoll?: string;
    Status: number;
    ProjectStatus: {
        Id: number;
        ReportAcquisition: boolean;
        Settlement: boolean;
        Editing: boolean;
        AssignmentGeneration: boolean;
    };
    Vsk: number;
}